import { useRouteError } from 'react-router';

const Error = () => {
  const error = useRouteError();

  console.error(error); // for debugging

  return (
    <div className="flex min-h-screen flex-col items-center justify-center bg-gray-100 p-4 text-center">
      <h1 className="mb-4 text-4xl font-bold text-red-600">Oops!</h1>
      <p className="mb-2 text-lg text-gray-700">Something went wrong.</p>
      <p className="text-md mb-6 text-gray-500">{error?.statusText || error?.message || 'Unknown error occurred.'}</p>
      <a href="/" className="text-blue-500 hover:underline">
        ← Back to Home
      </a>
    </div>
  );
};

export default Error;
